import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	csmCustomerContextTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.csm-customer-context-title',
		defaultMessage: 'Customer and organization profiles',
		description: 'Title text of the customer context feature panel',
	},
	csmCustomerContextBadge: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.csm-customer-context-badge',
		defaultMessage: 'Early Access',
		description: 'Badge text of the customer context feature panel',
	},
	csmCustomerContextDescriptionForIph: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.csm-customer-context-description-for-iph',
		defaultMessage:
			'Create profiles of your customers and organizations to get important information about them when working on issues. {learnMoreLink}',
		description:
			'Description that explains the affects of customer service management. {learnMoreLink} will be replace by a button, it does not need translation',
	},
	csmCustomerContextLearnMore: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.csm-customer-context-learn-more',
		defaultMessage: 'Read more about customer and organization profiles. ',
		description: 'Text used in customer service management learn more link',
	},
	csmCustomerContextDetailsTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.csm-customer-context-details-title',
		defaultMessage: 'Customer service management features',
		description: 'Text used in customer service management details header',
	},
	csmCustomerContextContactAdmin: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.csm-customer-context-contact-admin',
		defaultMessage: 'Contact your Jira admin to enable or disable this feature.',
		description: 'Prompt in customer service management to contact Jira admin to enable',
	},
	csmCustomerContextContactSuccessTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.csm-customer-context-contact-success-title',
		defaultMessage: `Customer service management {value, select,
            false {disabled}
            true {enabled}
            other {}
        }`,
		description: 'Title text of success flag',
	},
	successFlagTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.success-flag-title',
		defaultMessage: `{feature, select,
            csm_customer_context {Customer service management}
            products_and_entitlements {Products and entitlements}
            other {unknown}
        } {value, select,
            false {turned off}
            true {enabled}
            other {}
        }`,
		description: 'Title text of success flag',
	},
	successEnableDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.success-enable-description',
		defaultMessage:
			'Start using customer support features on the Customers and Organizations pages.',
		description: 'Body text of success flag when feature is enabled',
	},
	successDisableDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.success-disable-description',
		defaultMessage: 'You can enable this feature again at any time.',
		description: 'Body text of success flag when feature is disabled',
	},
	successEnableAction: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.success-enable-action',
		defaultMessage: 'Go to Customers page',
		description: 'Label used in action button in success flag when feature is enabled',
	},
	successDisableDismiss: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.success-disable-dismiss',
		defaultMessage: 'OK',
		description: 'Label used in dismiss button in success flag when feature is disabled',
	},
	productsAndEntitlementsFeatureTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.csm-features.customer-context.products-and-entitlements-feature-title',
		defaultMessage: 'Products and entitlements',
		description: 'Title text of the products and entitlements feature shown in confirmation flag',
	},
});
